import { render } from "./AdditionalInformation.vue?vue&type=template&id=59f38daa&scoped=true&ts=true"
import script from "./AdditionalInformation.vue?vue&type=script&lang=ts"
export * from "./AdditionalInformation.vue?vue&type=script&lang=ts"

import "./AdditionalInformation.vue?vue&type=style&index=0&id=59f38daa&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/my-pages-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f38daa"]])

export default __exports__